<template>
    <div class="rights-footer" v-if="rights">
      <span class="rights-text">{{ rights }}</span>
    </div>
  </template>
  
  <script>
  import { ref, onMounted } from 'vue';
  import axios from 'axios';
  export default {
    props: {
      exhibitId: {
        type: String,
      },
    },
    setup(props) {
      const rights = ref('');
      // Fonction pour récupérer les droits d'auteur depuis l'API
      const fetchRights = async () => {
        try {
            let exhibitId = props.exhibitId;
            let url = `${process.env.VUE_APP_BASEURL}/rights/${exhibitId}`;
            var response = await axios.get(url);
            rights.value = response.data[0].right_name;
        } catch (error) {
          console.log(error);
        }
      };
  
      // Appeler la fonction de récupération des droits au chargement du composant
      onMounted(fetchRights);
  
      return {
        rights,
      };
    },
  };
  </script>
  
  <style scoped>
  .rights-footer {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 20%;
    height: auto;
    padding: 5px;
    background-color: #f5f5f5;
    text-align: center;
    z-index: 10000;
    border-radius: 5px;
  }
  
  .rights-text {
    font-size: 12px;
    color: #888888;
  }
  </style>
  